import { ChevronLeft, ChevronRight } from 'lucide-react';

import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';

interface Props {
  pagina: number;
  totalPaginas: number;
  total: number;
  porPagina: number;
  aoMudarPagina: (pagina: number) => void;
  className?: string;
}

/**
 * Paginação das listagens de admin.
 *
 * Mostra o intervalo ("21–40 de 137") em vez de só o número da página: numa
 * tela de administração, saber quantos registros existem é a informação que o
 * usuário realmente procura.
 *
 * Página única não some — vira só o contador. Some o controle, não a contagem.
 */
export function Paginacao({
  pagina,
  totalPaginas,
  total,
  porPagina,
  aoMudarPagina,
  className,
}: Props) {
  const primeiro = total === 0 ? 0 : (pagina - 1) * porPagina + 1;
  const ultimo = Math.min(pagina * porPagina, total);

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-4 px-6 py-3 border-t border-brand/10',
        className,
      )}
    >
      <p className="text-xs text-muted-foreground">
        {total === 0 ? 'Nenhum registro' : `${primeiro}–${ultimo} de ${total}`}
      </p>

      {totalPaginas > 1 && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => aoMudarPagina(pagina - 1)}
            disabled={pagina <= 1}
            aria-label="Página anterior"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>

          <span className="text-xs text-muted-foreground tabular-nums">
            {pagina} / {totalPaginas}
          </span>

          <Button
            variant="outline"
            size="sm"
            onClick={() => aoMudarPagina(pagina + 1)}
            disabled={pagina >= totalPaginas}
            aria-label="Próxima página"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
}
